import React from 'react';

import { BasicRequestParser } from '../constants';
import { AssetOptions } from 'cb-utils/console-entity-models';
import { TriggerSourceDefinition } from '../types';

const AssetDeleted: TriggerSourceDefinition = {
  name: AssetOptions.AssetDeleted,
  getSummary: () => (
    <div>
      <em>Asset Deleted</em>
    </div>
  ),
  requestParser: BasicRequestParser,
  conditionOptions: [],
};

export default AssetDeleted;
